import { PanelProps } from '@blueprintjs/core';
import * as React from 'react';

import { refreshDataSources } from 'src/actions/data-sources/action-creators/refreshDataSources';
import { DialogConnectionTile } from 'src/components/DialogConnectionTile';
import { TEST_IDS } from 'src/constants/testIds';
import {
  DataSourceTypeSelectionPanel,
  DataSourceTypeSelectionPanelProps,
} from 'src/containers/DataSourceCreation/DataSourceTypeSelectionPanel/DataSourceTypeSelectionPanel';
import { FileUploadTile } from 'src/containers/DataSourceCreation/ResourceTypePanel/FileUploadTile';
import {
  ProjectFileUploadCreationPanel,
  ProjectFileUploadCreationPanelProps,
} from 'src/containers/ProjectResourceDialog/ProjectFileUploadCreationPanel/ProjectFileUploadCreationPanel';
import { ProjectResourceDialogPanelProps } from 'src/containers/ProjectResourceDialog/types';
import * as copy from 'src/templates/copy';
import { useIsMounted } from 'src/utils/hooks/useIsMounted';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';

export type ResourceTypePanelProps = ProjectResourceDialogPanelProps;

export const ResourceTypePanel: React.VFC<
  PanelProps<ResourceTypePanelProps>
> = ({ setFooterProps, openPanel }) => {
  const isMounted = useIsMounted();
  const dispatch = useReduxDispatch();
  React.useEffect(() => {
    if (isMounted.current) {
      setFooterProps({});
    }
  }, [isMounted, setFooterProps]);

  const handleDroppedFiles = (files: File[]) => {
    const props: ProjectFileUploadCreationPanelProps = {
      setFooterProps,
      // leaving in because previous work seems to indicate files are null sometimes?
      // maybe unnecessary check
      uploadedFiles: files.filter((file) => Boolean(file)),
    };
    openPanel({
      renderPanel: ProjectFileUploadCreationPanel,
      props,
    });
  };

  const handleRefreshDataSources = React.useCallback(() => {
    dispatch(refreshDataSources());
  }, [dispatch]);

  const handleProceedWithConnection = () => {
    const props: DataSourceTypeSelectionPanelProps = {
      setFooterProps,
    };
    handleRefreshDataSources();
    openPanel({
      renderPanel: DataSourceTypeSelectionPanel,
      props,
    });
  };

  return (
    <div className="sd-resource-type-panel">
      <p className="sd-resource-type-panel__description">
        {copy.components.projectResourceDialog.resourceTypePanel.description}
      </p>
      <div className="sd-resource-type-panel__tile-wrapper">
        <FileUploadTile handleDroppedFiles={handleDroppedFiles} multiple />
        <DialogConnectionTile
          cardClassName="sd-resource-type-panel__tile"
          handleProceedWithConnection={handleProceedWithConnection}
          hideSwitchConnections
          proceedButtonTestId={
            TEST_IDS.projectResourceDialog.resourceTypePanel.proceedButton
          }
          switchConnectionTestId={
            TEST_IDS.projectResourceDialog.resourceTypePanel.switchConnection
          }
          title={
            copy.components.projectResourceDialog.resourceTypePanel.connection
              .title
          }
        />
      </div>
    </div>
  );
};
